import React from 'react'
import OnlyOnApp from '../OnlyOnApp'

export default function Preappointment() {
    return (
        <OnlyOnApp
            pageTitle="Confirmar agendamento"
            title={
                <div className="text-lg">
                    A confirmação do agendamento é feita{' '}
                    <strong>exclusivamente pelo app da Camim</strong>
                </div>
            }
        />
    )
}
